<template>
  <div class="w-full flex flex-col justify-center items-center bg-themeComponentBg-light px-5 lg:px-0 font-rubik">
    <div class="solution-html-container font-rubik w-full max-w-992">
      <h2 class="solution-title">{{ getSolutionTitle() }}</h2>
      <div class="solution-content" v-html="solution.html_content"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    solution: {
      type: Object,
      required: true
    },
    organization: {
      type: Object,
      required: true
    }
  },
  methods: {
    getSolutionTitle() {
      const title = this.solution.title

      if (/Sales/.test(title)) {
        return 'Buy The Shipping Container That Meets Your Specific Needs'
      } else if (/Rentals/.test(title)) {
        return 'Shipping Container Rental'
      } else if (/Refrigerated/.test(title) && /Rental/.test(title)) {
        return 'Refrigerated Container Rental'
      } else if (/Refrigerated/.test(title)) {
        return 'Refrigerated Shipping Container For Sale'
      } else if (/Portable/.test(title)) {
        return 'Portable Office Container For Sale'
      } else {
        return `${this.organization.name} - ${title}`
      }
    }
  }
}
</script>

<style scoped>
.solution-html-container {
  margin-top: 128px;
  color: black;
}
.solution-title {
  margin-bottom: 25px;
  font-size: 48px;
  font-weight: 400;
  line-height: 57.6px;
  letter-spacing: -0.04em;
}
.solution-content {
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
}

/* mobile */
@media(max-width: 1024px) {
  .solution-html-container {
    margin-top: 40px;
  }
  .solution-title {
    margin-bottom: 25px;
    font-size: 32px;
    font-weight: 400;
    line-height: 38.4px;
    letter-spacing: -0.04em;
  }
  .solution-content {
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
    letter-spacing: -0.02em;
  }
}
</style>
